import {
    FETCH_STORES_LIST_SUCCESS,
    FETCH_STORE_BY_ID_SUCCESS,
    FETCH_GEOLOCATION_BY_POSTAL_CODE_SUCCESS,
    STORES_REQUEST_LOADING,
    STORES_REQUEST_ERRORS,
} from "api/menu/master-files/stores/actions";

const initialState = {
    loading: false,
    errors: [],
    geoLocation: null,
    stores: [],
    singleStore: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case STORES_REQUEST_LOADING:
            return {
                ...state,
                loading: true
            };
        case STORES_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_STORES_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                stores: action.payload
            };
        case FETCH_STORE_BY_ID_SUCCESS:
            return {
                ...state,
                singleStore: action.payload
            };

        case FETCH_GEOLOCATION_BY_POSTAL_CODE_SUCCESS:
            return {
                ...state,
               loading: false,
               geoLocation: action.payload
            };
        default:
            return state;
    }
}
